var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"running-pill"},[(_vm.showLabel)?_c('span',[_vm._v("RUNNING")]):_vm._e(),_c('div',{staticClass:"running-pill__dot"})])}
var staticRenderFns = []

export { render, staticRenderFns }